import React, {Component} from 'react';
import { Popover } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';

class StageInventoryPopover extends Component {

    render() {
        let jobs = this.props.stageType.jobs;

        const headerStyle = {
            backgroundColor: '#f0f0f0'
        };

        const columns = [
            {
                dataField: 'archive',
                text: 'Archive',
                headerStyle: headerStyle,
            },
            {
                dataField: 'engine',
                text: 'Engine',
                headerStyle: headerStyle,
            },
            {
                dataField: 'project',
                text: 'Project',
                headerStyle: headerStyle,
            },
            {
                dataField: 'job',
                text: 'Job',
                headerStyle: headerStyle,
            },
            {
              dataField: 'count',
              text: 'Count',
              headerStyle: headerStyle
            }
        ];

        return (
          <Popover id="popover-basic" title="Stage Inventory">
              <div>
                <h3>{this.props.stageType.stageType}</h3>
                <h4 style={{ color: '#777' }}>
                    Total Count: <span>{this.props.stageType.count}</span>
                </h4>
              </div>
              <BootstrapTable
                  keyField='job'
                  data={ jobs }
                  columns={ columns }
              />
          </Popover>
        );
    }
};

export default StageInventoryPopover;
